<template>
     <div v-if="loading && !gc" class="d-flex align-center justify-center">
        <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
    </div>
    <div v-else-if="error">
        <v-alert type="error">
            <span v-if="error">{{ $translate('Error loading game class') }}</span>
        </v-alert>
    </div>
    <div v-else-if="gc">
        <v-sheet color="primary" class="pa-4">
            <h2 class="primarytext--text">{{gc.name}}</h2>
        </v-sheet>

        <v-expansion-panels multiple v-model="expandedPanels">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>{{$translate('Divisions')}}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="z-dense">
                    <v-row>
                        <v-col v-for="division in divisions" :key="division.id" cols="12" md="6" lg="3">
                            <v-card>
                                <v-card-title class="primary--text">
                                    {{ division.name }}
                                </v-card-title>
                                <v-card-text class="pb-0">
                                    <div v-for="team in division.teams" :key="team.id" class="mb-1">
                                        <v-avatar size="30" class="mr-1">
                                            <v-img :src="'/api/public/image/get?size=50x50&type=team&id=' + team.id"></v-img>
                                        </v-avatar>
                                        <span class="font-weight-bold">{{ team.name }}</span>
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn block color="primary" @click="gotoResults(division)">{{$translate('Results & schedule')}}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPlayoffTree">
                <v-expansion-panel-header>
                    <h2>{{$translate('Playoff tree')}}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="z-dense">
                    <TeamsportPlayoffTree :gameClassId="gameClassId" />
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>{{$translate('Matches')}}</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="z-dense">
                    <teamsport-matches :gameClassId="gameClassId" :isIndividual="gc.individual" @onMatchesLoaded="onMatchesLoaded" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import TeamsportMatches from './TeamsportMatches.vue'
import TeamsportPlayoffTree from './TeamsportPlayoffTree.vue';
export default {
    name: 'zoezi-teamsport-gameclass-overview',

    zoezi: {
        title: 'Game class overview',
        icon: 'mdi-view-dashboard-outline',
        addon: 'TeamSports'
    },

    components: {
        TeamsportMatches,
        TeamsportPlayoffTree
    },

    props: {
        gameClassId: {
            title: 'Game class ID',
            type: Number
        }
    },

    data: () => ({
        loading: false,
        error: false,
        gc: null,
        expandedPanels: [2]
    }),

    computed: {
        showPlayoffTree() {
            return this.$store.state.settings?.modules.Cup && this.gc.steps.length > 1;
        },
        divisions() {
            return (this.gc?.steps[0]?.divisions || []).sort((a, b) => a.name.localeCompare(b.name, undefined, {numeric: true}));
        }
    },

    watch: {
        gameClassId: {
            immediate: true,
            handler() {
                if (!this.gameClassId) return
                this.loading = true
                this.$api.get('/api/teamsport/gameclass/get_for_memberpage', {id: this.gameClassId, include_teams: true}).then((gc) => {
                    const teamIdsNotRemovedFromGc = gc.teams.map(t => t.id);
                    gc.steps.forEach(step => {
                        step.divisions.forEach(division => {
                            division.teams = division.teams.filter(t => teamIdsNotRemovedFromGc.includes(t.id)).sort((a, b) => a.name.localeCompare(b.name));
                        })
                    })
                    this.gc = gc
                    this.loading = false
                }).catch(() => {
                    this.error = true
                    this.loading = false
                })
            }
        }
    },

    methods: {
        gotoResults(division) {
            const divisionPage = this.$root.siteconfig.pages?.division;
            this.$root.followLink(divisionPage, division.id);
        },
        onMatchesLoaded(matches) {
            if (this.showPlayoffTree) {
                let firstStepMatches = matches.filter(match => this.divisions.find(division => division.id == match.division_id))
                let otherMatches = matches.filter(match => !firstStepMatches.includes(match))

                let groupPlayPhase = firstStepMatches.some(match => !match.finished)
                let knockoutPhase = otherMatches.some(match => !match.finished)

                if (groupPlayPhase && knockoutPhase) {
                    this.expandedPanels = [0,1,2];
                } else if (groupPlayPhase) {
                    this.expandedPanels = [0,2];
                } else if (knockoutPhase) {
                    this.expandedPanels = [1,2];
                } else {
                    this.expandedPanels = [2];
                }
            }
        }
    }
}
</script>